import React from "react";
import { clsx } from "clsx";
import dayjs from "dayjs";
import { Link } from "gatsby";
import { authors } from "../data/author";

interface IPostMetadataProps extends React.PropsWithChildren {
  post: Queries.MicrocmsPost;
}

export default function PostMetadata(props: IPostMetadataProps) {
  const { post } = props;

  const author = authors.find((author) => post.authorId?.includes(author.id));

  const publishedAt = dayjs(post.publishedAt);
  const updatedAt = dayjs(post.updatedAt);

  return (
    <div
      className={clsx(
        "flex",
        "flex-col",
        "items-center",
        "justify-center",
        "lg:max-w-3xl",
        "md:max-w-2xl",
        "space-y-4",
        "px-4",
      )}
    >
      <Link
        className={clsx(
          "flex",
          "items-center",
          "justify-center",
          "space-x-4",
          "px-4",
        )}
        to={`/authors/${post.authorId}`}
      >
        <div className="avatar">
          <div className="w-12 rounded-full p-2 bg-primary/25">
            <img src={author?.imageUrl} alt="著者の画像" />
          </div>
        </div>
        <div>
          <p className={clsx("font-bold", "text-sm")}>{author?.name}</p>
        </div>
      </Link>

      <div className={clsx("flex", "flex-col", "items-center")}>
        <p className={clsx("font-light", "text-xs")}>
          公開: {publishedAt.format("YYYY/MM/DD")}
        </p>
        {!updatedAt.isSame(publishedAt, "day") &&
          updatedAt.isAfter(publishedAt) && (
            <p className={clsx("font-light", "text-xs")}>
              更新: {updatedAt.format("YYYY/MM/DD")}
            </p>
          )}
      </div>
    </div>
  );
}
